
/** build error object
 *
 * @param jsonString JSON string array (occassionally malformed)
 * @param error Type of error
 *
 * @returns { Object } Error report object
 * @example {
    message: 'FAILED TO PARSE JSON STRING',
    jsonString: 'original json string'
    error: Error('type of error')
  };
 *
 */
function buildError(jsonString, error) {
  return {
    message: 'FAILED TO PARSE JSON STRING',
    jsonString,
    error
  };
}

/** Parse JSON strings but dont crash out if the string is malformed or invalid.
 *
 * @param jsonString JSON string array (occassionally malformed)
 *
 * @returns { Array || Object } returns either parsed json or error object describing error
 * @example {
    message: 'FAILED TO PARSE JSON STRING',
    jsonString: 'original json string'
    error: Error('type of error')
  };
 *
 */
function safeParseJSON(jsonString) {
  let response;
  if(jsonString === null) return buildError(jsonString, new TypeError('Invalid input, expected json string'));
  try {
    response = JSON.parse(jsonString);
  } catch (error) {
    response = buildError(jsonString, error);
  }
  if(!response) {
    response = buildError(jsonString, new SyntaxError('invalid json string'));
  }
  return response;
}

export default safeParseJSON;



// WEBPACK FOOTER //
// ./src/utilities/safeParseJSON.js